var map = {
	"./": 3271,
	"./development": 2478,
	"./development.js": 2478,
	"./index": 3271,
	"./index.js": 3271,
	"./production": 276,
	"./production.js": 276,
	"./testing": 5071,
	"./testing.js": 5071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9607;